import { render } from "./TenpoTokuten.vue?vue&type=template&id=47fa7cb0"
import script from "./TenpoTokuten.vue?vue&type=script&lang=js"
export * from "./TenpoTokuten.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__